import MessageBox from "../components/message-box";
import moment from "moment";
import Report from "@xpeng/report-js";

export const showToastError = (error: any) => {
  if (typeof error === "string") {
    MessageBox.toast(error);
  } else if (typeof error === "object" && error.code) {
    MessageBox.toast(`${error.msg || error.message || ""}`);
  } else if (error instanceof Error) {
    MessageBox.toast(error.toString());
  }
};

export function isAfterDay(date: string, day: number) {
  // date YYYY-MM-DD 是否是 day 内
  if (!date) {
    return true;
  }
  const selectData = moment(date, "YYYY-MM-DD");
  const currentData = moment().format("YYYY-MM-DD");
  const maxData = moment(currentData, "YYYY-MM-DD").add(day, "days");
  if (selectData.isAfter(maxData)) {
    // 7天后
    return true;
  }
  return false;
}

/**
 * 从 useragent 获取 APP 版本信息，返回版本数组，如：[2, 15, 5]
 */
export function getAppVersionFromUserAgent(): number[] {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const matchText = userAgent.match(/com\.(.*)\/\d{1,3}\.\d{1,3}\.\d{1,3}/);
  const appVersion =
    matchText && matchText.length ? matchText[0].split("/")[1] : "0.0.0";

  if (/\d{1,3}\.\d{1,3}\.\d{1,3}/.test(appVersion)) {
    return appVersion.split(".").map(Number);
  }

  return [0, 0, 0];
}

export function formatVehiclePlate(plate: string): string {
  return plate.slice(0, 2) + "·" + plate.slice(2);
}

export function desensitizedVin(vin: string): string {
  return vin && vin.length === 17
    ? vin.slice(0, 3) + "***" + vin.slice(-3)
    : "--";
}

export function isXpAPP() {
  const UA = window.navigator.userAgent;

  return (
    UA.indexOf("XiaoPengQiChe") !== -1 ||
    UA.indexOf("xiaopeng") !== -1 ||
    UA.indexOf("com.tentcoo.XiaoPengQiCheEnterprise") !== -1
  );
}

export enum PLATFORM {
  ANDROID = "android",
  IOS = "iOS",
  HARMONY = "harmony",
  PC = "PC",
}

export function getPlatform() {
  const u = window.navigator.userAgent;

  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
  if (isAndroid) return PLATFORM.ANDROID;

  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
  if (isIOS) return PLATFORM.IOS;

  const isHarmony = !!/Harmony/i.test(u);
  if (isHarmony) return PLATFORM.HARMONY;

  return PLATFORM.PC;
}

export function isAndroid() {
  return getPlatform() === PLATFORM.ANDROID;
}

export function isIOS() {
  return getPlatform() === PLATFORM.IOS;
}

export function isHarmony() {
  return getPlatform() === PLATFORM.HARMONY;
}


/**
 * 返回当前页面的环境，依赖于当前域名
 */
export function getClientEnv() {
  const hostname = window.location.hostname;
  if (hostname === 'das.xiaopeng.com') {
    return 'production'
  }
  if (hostname === 'das.deploy-test.xiaopeng.com') {
    return 'pre'
  }
  if (hostname === 'das.test.xiaopeng.com') {
    return 'test';
  }
  return "dev";
}

/**
 * 是否是 mock 环境
 */
export function isMock() {
  return process.env.REACT_APP_DATA_SOURCE === 'mock'
}

export function reportUserBehavior(
  { appid = "J001", so, mcode, pa = "", ch = "" },
  type = "event"
) {
  const env = getClientEnv() === "dev" ? "test" : getClientEnv();
  const report = new Report(
    {
      appid,
      so,
      mcode,
      pa,
      ch,
    },
    {
      env,
    }
  );

  report.send({ type });
}

/**
 * 获取距离展示值
 * @param  {String} dist 距离值，以米为单位
 * @return {String}          距离展示值
 */
export function getDistanceText(dist) {
  const distance = Number(dist);
  if (distance < 1000) {
    return `${distance} m`;
  } else if (distance / 1000 < 1000) {
    return `${(distance / 1000).toFixed(1)} km`;
  } else if (distance / 1000 > 9999) {
    return "9999 km";
  }
  return `${(distance / 1000).toFixed(0)} km`;
}

/**
 * 格式化时间
 * @param  {String} date 时间
 * @return {String}      格式化后的时间
 */
export function formatTimestamp(date?: number) {
  const { hours, minutes, seconds } = moment(date).toObject();

  if (hours === 0 && minutes === 0 && seconds === 0) {
    return moment(date).format("YYYY-MM-DD");
  } else {
    return moment(date).format("YYYY-MM-DD HH:mm");
  }
}

// 把 adCode 转换成 provinceCode 和 cityCode
export const convertAdcode = adCode => {
  if (!adCode) return [];
  const code = parseInt(adCode);
  const cityCode = Math.floor(code / 100) + "";
  const provinceCode = Math.floor(code / 10000) + "";
  return [
    provinceCode,
    cityCode
  ]
}

// 判断是否是无值
export const isNill = (value) => value === null || value === undefined || value === '';